import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from 'common/api'

const INITIAL_STATE = {
  hasUnreadMessage: false,
}

type APISearchUnread = unknown[]

const populateUnreadMessageFlag = createAsyncThunk('messaging/populateUnreadMessageFlag', async () => {
  const discussions = await api.get<APISearchUnread>('/api/discussions?search=unread')
  const unreadCount = discussions?.length ?? 0
  return unreadCount > 0
})

const slice = createSlice({
  name: 'messaging',
  initialState: INITIAL_STATE,
  reducers: {
    updateUnreadMessageFlag: (state, action) => {
      state.hasUnreadMessage = action.payload
    },
  },
  extraReducers(builder) {
    builder.addCase(populateUnreadMessageFlag.fulfilled, (state, action) => {
      state.hasUnreadMessage = action.payload
    })
  },
})

export const actions = {
  ...slice.actions,
  removeUnreadMessageFlag: () => slice.actions.updateUnreadMessageFlag(false),
  turnOnUnreadMessageFlag: () => slice.actions.updateUnreadMessageFlag(true),
  populateUnreadMessageFlag,
}

export default slice.reducer
